import React from "react";
import { func } from "prop-types";
import { Button, Badge } from "react-bootstrap";

const SupportBotSection = (props) => {
  const { toggleHelpAssistantModal } = props;

  return (
    <div className="help-center-section">
      <p className="mb-2">
        Have a question? Try asking our AI Assistant.{" "}
        <Badge className="new-badge">Beta</Badge>
      </p>
      <Button
        variant="primary"
        className="text-center w-100"
        onClick={toggleHelpAssistantModal}
      >
        Launch Assistant
      </Button>
    </div>
  );
};

SupportBotSection.propTypes = {
  toggleHelpAssistantModal: func,
};

export default SupportBotSection;
